import {Box, Card, CardMedia, CircularProgress, Grid, List, ListItem, ListItemText, useMediaQuery, useTheme} from '@mui/material';
import {Typography} from '@mui/material';
import Button from "@mui/material/Button";
import React from 'react';
import styles from './upNext.module.css';
import {
    clickUpNextProductRecommendation,
} from "../../mixPanelEvents/mixPanelEvents";
import PresentBox from "../../icons/presentBox";
import { Promo } from '../../../interfaces/promo';
import { Accelerator } from '../../../interfaces/accelerator';
import { CurrentLesson } from '../../../interfaces/currentLesson';

const UpNext = ({ promo, accelerator, lesson}: {
    promo?:Promo | null,
    accelerator:Accelerator,
    lesson:CurrentLesson
}) => {
    const theme = useTheme();

    return (    

    <Box  className={styles.playlistPromo}>
        <Grid marginTop={"5px"} marginBottom={"10px"} paddingLeft={"10px"} sx={{display:'flex', flexDirection: 'row', alignItems:"center"}}>
            <PresentBox width={29} height={29}/> <Typography marginLeft={"5px"}>Recommended For You</Typography>
            <div className={styles.ribbon}>
                <span>WHAT’S NEXT</span>
            </div>
        </Grid>
        <Grid item md={12} xs={12} marginLeft={"10px"} paddingTop={"20px"} paddingBottom={"10px"} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Grid item md={4} lg={4} xl={3} padding={0} margin={0}>
                <Card sx={{height: "51px", width:"83px", borderRadius:"unset"}} >
                    <CardMedia
                        sx={{height: "51px"}}
                        component="img"
                        alt="Random Course"
                        image={promo?.image}
                    />
                </Card>
            </Grid>
            <Grid item md={8} lg={8} xl={9} marginLeft={"10px"} marginRight={"10px"}>
            <Typography fontSize={{xs: "16px",md: "16px", lg: "16px", xl:"18px"}} sx={{fontSize:"18px", fontWeight:800,lineHeight: "100%"}}>{promo?.name}</Typography>
            </Grid>
        </Grid>
        <Grid item md={12} xs={12} paddingBottom={"10px"} margin={0} sx={{ display: 'flex', height: "45%", flexDirection: 'row', alignItems: 'center', backgroundColor:"#1B84FF0A" }}>
            <Grid item md={9}>
                {/* <List sx={{
                    listStyleType: 'disc',
                    alignItems: 'center',
                    margin: "auto",
                    color: "black",
                    paddingLeft: "20px",
                    paddingTop: "5px"
                }}>
                    <ListItem sx={{display: 'list-item', padding: 0, '&::marker': {fontSize: "12px"}}}>
                        <ListItemText sx={{margin: 0}} primaryTypographyProps={{fontSize: 12, fontWeight: 400, lineHeight: "15px"}}>
                            Bullet-One
                        </ListItemText>
                    </ListItem>
                    <ListItem sx={{display: 'list-item', padding: 0, '&::marker': {fontSize: "12px"}}}>
                        <ListItemText sx={{margin: 0}} primaryTypographyProps={{fontSize: 12,fontWeight: 400,lineHeight: "15px"}}>
                            Bullet-Two
                        </ListItemText>
                    </ListItem>
                    <ListItem sx={{display: 'list-item', padding: 0, '&::marker': {fontSize: "12px"}}}>
                        <ListItemText sx={{margin: 0}} primaryTypographyProps={{fontSize: 12,fontWeight: 400,lineHeight: "15px"}}>
                            Bullet-three
                        </ListItemText>
                    </ListItem>
                    <ListItem sx={{display: 'list-item', padding: 0, '&::marker': {fontSize: "12px"}}}>
                        <ListItemText sx={{margin: 0}} primaryTypographyProps={{fontSize: 12,fontWeight: 400,lineHeight: "15px"}}>
                            Bullet-four
                        </ListItemText>
                    </ListItem>
                </List> */}
                <Typography sx={{fontSize: "14px", fontWeight: 400, lineHeight: "15px", paddingLeft: "20px", paddingRight:"10px"}}>{promo?.promo_text}</Typography>
            </Grid>
            <Grid item md={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button sx={{ marginRight: '20px' }} onClick={() => { clickUpNextProductRecommendation("End of Playlist", lesson, accelerator, ""); promo?  window.location.href = promo?.url: console.log("no url");}}
                        className={styles.playlistPromoBtn}>
                    <Typography sx={{fontSize:"16px" ,fontWeight: 800, whiteSpace: "nowrap"}}>Get Started</Typography>
                </Button>
            </Grid>
        </Grid>
    </Box>

)};
export default UpNext;